export default __webpack_public_path__ + "static/media/gallery-add-img-1.d47029f1.jpg";